import * as images from "@/components/images/Images";
import { UseCasesHeroData } from "./types";
import { ROUTES } from "@/constants";

const useCasesHeroContent = {
  title: "Professional translation services for any use case",
  description:
    "Ensure accuracy with high-quality human translators specialized in your use case across 100+ languages for delivery in 24 hours.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  secondaryButton: {
    href: ROUTES.getQuote,
    label: "Get a quote",
  },
  imageUrl: images.useCaseHeroIMG,
  imageDimensions: {
    width: 1204,
    height: 1032,
  },
} as UseCasesHeroData;

export const useCasesHeroData = {
  ...useCasesHeroContent,
};
